// @flow

import { hashJson } from '../../../utils/hashJson';

/**
 * Compute whether Save should be disabled for AI Reports (Create or Edit modes).
 * Accepts both mode flags and baseline values to compare.
 */
export const getSaveDisabled = ({
  isLoading,
  inputsEnabled,
  reportJson,
  name,
  description,
  currentSpecHash,
  lastSavedSpecHash,
  inEditMode,
  baselineName,
  baselineDescription,
  baselineSpecHash,
}) => {
  const hasConfig = !!(
    reportJson && (reportJson.config || reportJson)
  );
  const trimmedName = String(name || '').trim();
  const trimmedDesc = String(description || '').trim();

  // Global gating
  if (isLoading) return true;
  if (!hasConfig) return true;
  if (!inputsEnabled) return true;
  
  // In edit mode, allow empty description if baseline was also empty
  // In create mode, require both name and description
  if (inEditMode) {
    if (!trimmedName) return true;
    // Allow empty description in edit mode if there are other changes
  } else {
    if (!trimmedName || !trimmedDesc) return true;
  }
  
  if (trimmedName.length > 50 || trimmedDesc.length > 200) return true;

  if (inEditMode) {
    // In edit mode enable save when there is any change vs baseline
    const nameChanged = trimmedName !== String(baselineName || '').trim();
    const descChanged =
      trimmedDesc !== String(baselineDescription || '').trim();
    const specChanged =
      !!baselineSpecHash && currentSpecHash && currentSpecHash !== baselineSpecHash;
    return !(nameChanged || descChanged || specChanged);
  }

  // Create mode: use lastSavedSpecHash to prevent saving identical spec
  if (currentSpecHash && lastSavedSpecHash === currentSpecHash) return true;
  return false;
};

export const computeSpecHash = ({ draftConfig, reportJson }) => {
  const effective = draftConfig || (reportJson && reportJson.config) || {};
  return hashJson(effective);
};
